module.exports = "/static/media/ios.e1d6dfe7.svg";